import { Icon } from '@innowise-group/mui-kit';
import React, { MouseEventHandler } from 'react';
import * as Styled from './avatar-menu.styles';

interface AvatarMenuProps {
  photoId?: number | string;
  miniPhotoUrl?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
  firstNameRu?: string;
  lastNameRu?: string;
  jobTitle?: string;
  inTwoColumn?: boolean;
}

const AvatarMenu: React.FC<AvatarMenuProps> = ({
  photoId,
  miniPhotoUrl,
  firstNameRu,
  lastNameRu,
  jobTitle,
  inTwoColumn,
  onClick,
}) => {
  return (
    <Styled.Container onClick={onClick} isPointer={!!onClick}>
      {photoId || miniPhotoUrl ? (
        <Styled.Avatar id={photoId} miniPhotoUrl={miniPhotoUrl} />
      ) : (
        <Styled.NoImageContainer>
          <Icon type="u_camera" size={25} viewBox="2 1 46 40" />
        </Styled.NoImageContainer>
      )}
      {(firstNameRu || lastNameRu || jobTitle) && (
        <Styled.InfoBlock>
          {inTwoColumn && <Styled.FullName>{lastNameRu}</Styled.FullName>}
          <Styled.FullName>
            {!inTwoColumn && lastNameRu} {firstNameRu}
          </Styled.FullName>
          <Styled.JobTitle>{jobTitle}</Styled.JobTitle>
        </Styled.InfoBlock>
      )}
    </Styled.Container>
  );
};

export default AvatarMenu;
